module.exports = __webpack_public_path__ + "img/pay1.3cf3efcb.png";